interface ISectionDoubts {
  id?: string;
}

export const SectionDoubts = ({ id }: ISectionDoubts) => {
  return (
    <div className="bottom-0 flex w-full flex-col bg-white p-[4.65rem] lg:translate-x-1" id={id}>
      <h2 className="heading-4 mb-2 text-black md:mb-0">Tem Dúvidas?</h2>
      <span className="text-body-2 text-left text-black lg:mb-12">
        Acesse agora nossa área de Perguntas Frequentes
      </span>
      <a
        href="/faq"
        className="group flex max-w-fit items-center border-b border-primaria-claro pb-2 font-semibold text-primaria-claro"
        title="Perguntas Frequentes"
      >
        <span>Perguntas Frequentes</span>
        <svg
          className="ml-3 transition-all ease-linear group-hover:rotate-45"
          width="12"
          height="14"
          viewBox="0 0 12 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.0168 13.0311C1.28008 13.0289 1.53189 12.9213 1.71752 12.7317L10.0013 4.30536L10.0013 8.96462C10.0013 9.23384 10.1066 9.49205 10.294 9.68242C10.4814 9.87279 10.7356 9.97974 11.0006 9.97974C11.2657 9.97974 11.5199 9.87279 11.7073 9.68242C11.8947 9.49205 12 9.23384 12 8.96462L12 1.85875C11.9985 1.7258 11.9713 1.59444 11.92 1.47213C11.8186 1.22463 11.6249 1.02791 11.3813 0.924916C11.2608 0.872762 11.1315 0.845142 11.0006 0.843627L4.00512 0.843628C3.74007 0.843628 3.48588 0.950578 3.29846 1.14095C3.11105 1.33132 3.00576 1.58952 3.00576 1.85875C3.00576 2.12798 3.11105 2.38618 3.29846 2.57655C3.48588 2.76692 3.74007 2.87388 4.00512 2.87388L8.59203 2.87387L0.296556 11.2883C0.202605 11.3827 0.128019 11.4951 0.0771149 11.619C0.0262116 11.7429 8.54222e-07 11.8758 8.65777e-07 12.01C8.77332e-07 12.1442 0.0262117 12.2771 0.077115 12.401C0.128019 12.5249 0.202605 12.6373 0.296556 12.7317C0.390797 12.828 0.503097 12.9041 0.62681 12.9555C0.750525 13.0069 0.883136 13.0326 1.0168 13.0311Z"
            fill="#1658A6"
          ></path>
        </svg>
      </a>
    </div>
  );
};
